module.exports = __webpack_public_path__ + "img/wait.a29a0ed6.png";